<script setup lang="ts">
import { computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useSubscription } from '@/features/subscription/composables/useSubscription'

const router = useRouter()
const route = useRoute()
const { paymentFailed, isOrganic, subscriptionIsPaid, allowUpgrade, shouldShowAlertBanner } =
	useSubscription()

const onSubscriptionPage = computed(() => route.name === 'Subscription')
const visible = computed(() => shouldShowAlertBanner.value && !onSubscriptionPage.value)

const message = computed(() => {
	if (paymentFailed.value) {
		return 'Your last subscription payment failed. Update your payment method to keep full access.'
	}
	if (isOrganic.value && !subscriptionIsPaid.value && allowUpgrade.value) {
		return 'Your free trial is ending soon. Choose a plan to keep all features.'
	}
	return ''
})

const severity = computed<'error' | 'warning'>(() => (paymentFailed.value ? 'error' : 'warning'))

function goToSubscription() {
	router.push({ name: 'Subscription' })
}
</script>

<template>
	<Transition name="slide-down">
		<v-alert
			v-if="visible"
			:type="severity"
			variant="tonal"
			rounded="0"
			class="subscription-alert-banner px-6 py-3"
			density="compact"
		>
			<div class="d-flex align-center flex-wrap ga-3">
				<div class="flex-grow-1">
					<i class="fa-solid fa-circle-exclamation mr-2" />
					<span>{{ message }}</span>
				</div>
				<v-btn
					size="small"
					color="primary"
					variant="flat"
					prepend-icon="fa-solid fa-arrow-right"
					@click="goToSubscription"
				>
					Manage subscription
				</v-btn>
			</div>
		</v-alert>
	</Transition>
</template>

<style scoped lang="scss">
.subscription-alert-banner {
	border-radius: 0 !important;
	border-left: none !important;
	border-right: none !important;
	border-top: none !important;
}
</style>
